import MonitoringInterfaceV1 from './MonitoringInterfaceV1';
import { MonitoringInterfaceV1Type } from './types';

export { createNoopMonitoringInterfaceV1 } from './NoopInterface';

let monitoringInterfaceV1: MonitoringInterfaceV1;

function _createMonitoringInterfaceV1() {
  return new MonitoringInterfaceV1();
}

export function getMonitoringInterfaceV1(): MonitoringInterfaceV1 {
  return monitoringInterfaceV1;
}

export default async function initializeMonitoringInterfaceV1(): Promise<MonitoringInterfaceV1Type> {
  if (monitoringInterfaceV1) return monitoringInterfaceV1.getInterface();
  monitoringInterfaceV1 = _createMonitoringInterfaceV1();

  return monitoringInterfaceV1.getInterface();
}
